const pieces = [
  {
    title: "Sangle de volet roulant",
    desc: "Si la sangle est également usée ou endommagée, nous la remplaçons en même temps que le cordon pour une manœuvre optimale.",
    icon: "ri-links-line",
  },
  {
    title: "Attaches et fixations",
    desc: "Les attaches du cordon ou de l'enrouleur usées peuvent provoquer des déraillements. Nous les vérifions et les remplaçons si besoin.",
    icon: "ri-anchor-line",
  },
  {
    title: "Guidage du cordon",
    desc: "Un guidage mal aligné ou usé peut effilocher le cordon prématurément. Nous vérifions et réglons ce point critique.",
    icon: "ri-guide-line",
  },
  {
    title: "Butées et arrêts",
    desc: "Les butées de fin de course usées peuvent provoquer des à-coups qui abîment le cordon. Nous les contrôlons systématiquement.",
    icon: "ri-stop-circle-line",
  },
];

export default function PiecesAssociees() {
  return (
    <section className="bg-[#F5F2EB] py-14 md:py-20">
      <div className="max-w-7xl mx-auto px-4 md:px-8">
        <h2 className="text-[#1B2A4A] text-2xl md:text-3xl font-extrabold text-center mb-3">
          Pièces associées vérifiées
        </h2>
        <p className="text-[#2F4A63] text-base text-center mb-10 md:mb-14 max-w-2xl mx-auto">
          Lors du remplacement de votre cordon et enrouleur, nous contrôlons aussi ces éléments pour garantir une réparation durable et complète.
        </p>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {pieces.map((piece) => (
            <div
              key={piece.title}
              className="bg-white rounded-xl border border-[#E2E8F0] p-5 md:p-6 hover:border-[#E8734A]/40 transition-colors"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-[#E8734A]/10 mb-4">
                <i className={`${piece.icon} text-[#E8734A] text-lg`}></i>
              </div>
              <h3 className="text-[#1B2A4A] text-base font-bold mb-2">{piece.title}</h3>
              <p className="text-[#2F4A63] text-sm leading-relaxed">{piece.desc}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}